import { InvoiceDiscountMode } from '../enums/invoiceDiscountMode'
import type { Quote } from '../types/quotes/quote'
import { hasInvoiceLineDiscount } from './hasInvoiceLineDiscount'

export const getQuoteDiscountMode = (quote?: Quote): InvoiceDiscountMode => {
  const hasLineDiscount = hasInvoiceLineDiscount(quote?.lines ?? [])

  if (hasLineDiscount) {
    return InvoiceDiscountMode.ByItem
  }

  if ((quote?.discount?.amount ?? 0) > 0) {
    return InvoiceDiscountMode.Global
  }

  return InvoiceDiscountMode.None
}
